import { render, staticRenderFns } from "./PromotionTemplate.vue?vue&type=template&id=d11650b8&"
import script from "./PromotionTemplate.vue?vue&type=script&lang=js&"
export * from "./PromotionTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports